const styles = theme => ({
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
  },
  optional: {
    fontWeight: 400,
    color: '#919EAB',
  },
  courseInfo: {
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
  },
  courseInfoTitleBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    transition: 'all 0.3s ease-out',
    maxHeight: '0px',
    opacity: 0,
    '&.open': {
      maxHeight: '100%',
      opacity: 1,
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  root_content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 8,
    padding: 12,
    border: '1px solid #e9ecef',
    backgroundColor: '#ffffff',
    gap: 16,
  },
  root_content_text: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: 12,
  },
  setting_header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  setting_title: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#002E47',
  },
  delete_button: {
    padding: 4,
    minWidth: 'auto',
  },
  root_content_text_description: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#002E47',
  },
  root_content_text_row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  root_content_text_column: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  auto_complete: {
    width: '100%',
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  },
  icon_button_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
  },
  divider: {
    height: 16,
    display: 'block',
    width: '100%',
  },
  button_container: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 8,
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '7px 14px',
    borderRadius: '999px',
    border: '1px solid #E5E7EB',
    backgroundColor: '#fff',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#015FFB',
      backgroundColor: '#E9F1FF',
      color: '#015FFB',
    },
  },
  // Image Settings specific styles
  imageSettingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    borderRadius: 8,
    padding: 16,
    border: '1px solid #e9ecef',
    backgroundColor: '#ffffff',
  },
  imageSettingsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  imageSettingsHeaderTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
  },
  imageSettingsTitle: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#002E47',
  },
  imageSettingsDescription: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#637381',
    lineHeight: '1.4',
  },
  imageSettingsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  imageSourceSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  imageSettingField: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  settingFieldTitle: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#002E47',
  },
  settingFieldDescription: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#637381',
    lineHeight: '1.4',
  },
  selectField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '& fieldset': {
        borderColor: '#e9ecef',
      },
      '&:hover fieldset': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      color: '#002E47',
      padding: '12px 16px',
    },
  },
  select: {
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    position: 'relative',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 8,
  },
  proBadgeContainer: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    pointerEvents: 'none',
  },
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '& fieldset': {
        borderColor: '#e9ecef',
      },
      '&:hover fieldset': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      color: '#002E47',
    },
  },
  formControl: {
    width: '100%',
  },
  formLabel: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#002E47',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
  },
  radio: {
    color: '#1976d2',
    '&.Mui-checked': {
      color: '#1976d2',
    },
  },
  radioLabel: {
    margin: 0,
    marginBottom: 8,
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      color: '#002E47',
      fontWeight: 400,
    },
    '&.Mui-disabled': {
      '& .MuiFormControlLabel-label': {
        color: '#9e9e9e',
        cursor: 'not-allowed',
      },
    },
  },
  // Style for selected radio button text
  selectedRadioLabel: {
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
    },
  },
})

export default styles
